module.exports = __webpack_public_path__ + "static/img/38.c673f283.png";